<template>
  <div>
    <van-popup
      v-model="visible"
      :close-on-click-overlay="true"
      :style="{ maxHeight: '100vh',paddingBottom: '56px' }"
      position="bottom"
      @close="onClose"
    >
      <div class="vip-popup">
        <!-- 头部标题 -->
        <div class="vip-popup__header">
          <div class="vip-popup__title">开通会员享受更多权益</div>
          <van-icon name="cross" size="20" @click="onClose"/>
        </div>

        <!-- 会员权益介绍 -->
        <div class="vip-popup__benefits">
          <div class="benefits-title">会员专享权益</div>
          <div class="benefits-list">
            <div class="benefit-item">
              <van-icon color="#ff8f3f" name="play-circle-o" size="20"/>
              <span>可观看会员专享课程</span>
            </div>
            <div class="benefit-item">
              <van-icon color="#ff8f3f" name="service-o" size="20"/>
              <span>康复专家线上远程指导</span>
            </div>
            <div class="benefit-item">
              <van-icon color="#ff8f3f" name="eye-o" size="20"/>
              <span>康复学习监督</span>
            </div>
            <div class="benefit-item">
              <van-icon color="#ff8f3f" name="clock-o" size="20"/>
              <span>康复训练打卡监督</span>
            </div>
          </div>
        </div>

        <!-- VIP套餐选择 -->
        <div class="vip-popup__plans">
          <div class="plans-title">选择套餐</div>
          <div class="plans-list">
            <div
              v-for="plan in vipPlans"
              :key="plan.id"
              :class="{ 'plan-item--selected': selectedPlan?.id === plan.id }"
              class="plan-item"
              @click="selectPlan(plan)"
            >
              <div class="plan-item__header">
                <div class="plan-item__name">{{ plan.name }}</div>
                <div class="plan-item__price-row">
                  <div class="plan-item__price">
                    <span class="price-symbol">¥</span>
                    <span class="price-amount">{{ plan.price }}</span>
                  </div>
                  <div class="plan-item__duration">有效期：{{ plan.duration }}</div>
                </div>
                <!-- 康复指导次数显示 -->
                <div v-if="plan.serviceCount > 0" class="plan-item__service-count">
                  <van-icon color="#ff8f3f" name="service-o" size="12"/>
                  <span>{{ plan.serviceCount }}次康复指导</span>
                </div>
              </div>
              <div class="plan-item__features">
                <div v-for="feature in plan.features" :key="feature" class="feature-item">
                  <van-icon color="#07c160" name="success" size="14"/>
                  <span>{{ feature }}</span>
                </div>
              </div>
              <div v-if="plan.recommended" class="plan-item__badge">推荐</div>
            </div>
          </div>
        </div>

        <!-- 底部购买按钮 -->
        <div class="vip-popup__footer">
          <van-button
            :disabled="!selectedPlan || !isDefaultMerchant"
            color="#ff8f3f"
            size="large"
            type="primary"
            @click="onPurchase"
          >
            {{ purchaseButtonText }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 支付成功弹窗 -->
    <van-popup
      v-model="showPaySuccessPopup"
      :close-on-click-overlay="false"
      class="success-popup-wrapper"
      position="center"
    >
      <div class="success-popup">
        <div class="success-popup__icon">
          <van-icon color="#07c160" name="success" size="60"/>
        </div>
        <div class="success-popup__title">支付成功</div>
        <div class="success-popup__content">
          <div class="success-info-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ outTradeNo }}</span>
          </div>
          <div class="success-info-item">
            <span class="label">支付时间：</span>
            <span class="value">{{ orderCreateTime }}</span>
          </div>
          <div class="success-info-item">
            <span class="label">购买套餐：</span>
            <span class="value">{{ selectedPlan?.name }}</span>
          </div>
          <div class="success-info-item">
            <span class="label">有效期：</span>
            <span class="value">{{ selectedPlan?.duration }}</span>
          </div>
        </div>
        <div class="success-popup__tip">
          恭喜您成为VIP会员！请截图保存此页面作为支付凭证
        </div>
        <van-button
          color="#ff8f3f"
          size="large"
          type="primary"
          @click="closeSuccessPopup"
        >
          确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import WxPayDao from '@/h5/doucan/network/WxPayDao'
import wx from 'weixin-jsapi'
import { Dialog, Toast } from 'vant'
import DateUtils from '@/utils/DateUtils'
import axios from 'axios'
import { DEFAULT_REHAB_MERCHANT, getRehabMerchantConfig } from '@/h5/doucan/pages/rehab_courses/merchantConfig'

export default {
  name: 'VipPurchasePopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    merchant: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      selectedPlan: null,
      // 支付相关数据
      from: 'wxapp', // 'wxapp' 表示小程序环境
      openid: '', // 微信用户标识
      hospitalId: '', // 医院ID
      paySignInfo: null, // 支付签名信息
      outTradeNo: '', // 订单号
      payStatus: false,
      orderCreateTime: null,
      remark: '',
      // 测试手机号（支付0.01元）
      testMobile: ['18008000808', '13610164743', '18520535303', '18501011010'],
      // 支付成功弹窗
      showPaySuccessPopup: false,
      vipPlans: [
        // {
        //   id: 1,
        //   name: '基础会员',
        //   price: 99,
        //   duration: '3个月',
        //   recommended: false,
        //   serviceCount: 0,
        //   features: [
        //     '自选3套会员课程',
        //     '康复学习监督'
        //   ]
        // },
        {
          id: 2,
          name: '标准会员',
          price: 289,
          duration: '3个月',
          recommended: true,
          serviceCount: 1,
          features: [
            '全量会员课程',
            '1次康复专家指导',
            '康复学习监督',
            '康复训练打卡监督',
            '优先客服支持'
          ]
        },
        {
          id: 3,
          name: '高级会员',
          price: 999,
          duration: '12个月',
          recommended: false,
          serviceCount: 4,
          features: [
            '全量会员课程',
            '4次康复专家指导',
            '康复学习监督',
            '康复训练打卡监督',
            '优先客服支持'
          ]
        }
      ]
    }
  },
  computed: {
    // 从store获取小程序参数
    miniProgramParams() {
      return this.$store.state.user.miniProgramParams
    },
    currentMerchantConfig() {
      return getRehabMerchantConfig(this.merchant)
    },
    isDefaultMerchant() {
      return this.currentMerchantConfig.key === DEFAULT_REHAB_MERCHANT.key
    },
    purchaseButtonText() {
      if (!this.selectedPlan) return '请选择套餐'
      return this.isDefaultMerchant ? `立即购买 ¥${this.selectedPlan.price}` : '暂不可购买'
    }
  },
  async mounted () {
    // 初始化支付环境
    await this.initPaymentEnvironment()
  },
  watch: {
    show: {
      immediate: true,
      handler (newVal) {
        this.visible = newVal
        if (newVal) {
          // 默认选择推荐套餐
          this.selectedPlan = this.vipPlans.find(plan => plan.recommended) || this.vipPlans[0]
        }
      }
    },
    visible (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  methods: {
    selectPlan (plan) {
      this.selectedPlan = plan
    },
    async onPurchase () {
      if (!this.selectedPlan) {
        this.$toast('请选择套餐')
        return
      }

      if (!this.isDefaultMerchant) {
        return
      }

      // 检查登录状态
      if (!this.checkLogin()) {
        this.$toast('请先登录')
        this.$router.push('/login/index?returnTo=rehab-courses')
        return
      }

      // 调起支付
      await this.pay()
    },
    onClose () {
      this.visible = false
    },
    checkLogin () {
      return this.$store.state.user.profile.isLogin
    },

    // 支付环境初始化
    async initPaymentEnvironment () {
      // 使用computed属性获取store中的参数
      if (this.miniProgramParams && this.miniProgramParams.from === 'wxapp') {
        this.from = this.miniProgramParams.from
        this.openid = this.miniProgramParams.openid
        this.hospitalId = this.miniProgramParams.hospitalId
        
        console.log('从store读取小程序参数:', this.miniProgramParams)
      } else {
        // 回退到URL参数或其他方式
        this.from = this.$route.query.from || ''
        this.openid = this.$route.query.openid || ''
        this.hospitalId = this.$route.query.hospitalId || ''
        
        console.log('使用URL参数或默认值:', {
          from: this.from,
          openid: this.openid,
          hospitalId: this.hospitalId
        })
      }

      console.log('支付环境初始化完成:', {
        from: this.from,
        openid: this.openid,
        hospitalId: this.hospitalId
      })

      // 根据环境初始化
      if (this.from === 'wxapp') {
        // 小程序环境
        console.log('小程序环境 - openid:', this.openid)
        console.log('小程序环境 - hospitalId:', this.hospitalId)
      } else if (this.isWeChatBrowser()) {
        // 微信浏览器环境
        await this.initWx()
      }
    },

    // 判断是否微信浏览器
    isWeChatBrowser () {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('micromessenger')
    },

    // 微信环境初始化
    async initWx () {
      await this.getAppid()
      const openid = this.$store.state.user.openId
      if (openid) {
        this.openid = openid
      } else {
        await this.getMpOpenID()
      }
    },

    // 核心支付方法
    async pay () {
      // 检查是否有用户手机号
      const userProfile = this.$store.state.user.profile
      console.log('支付-userProfile', userProfile)

      const patientMobile = userProfile.phone || ''
      const patientName = userProfile.name || ''

      if (!patientName || !patientMobile) {
        this.$toast('请先完善个人信息')
        return
      }

      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })

      // 计算支付金额
      const fee = this.calculateFee(patientMobile)

      // 构建订单数据
      const profile = this.buildOrderProfile(fee, patientName, patientMobile)

      console.log('支付-this.from', this.from);
      console.log('支付-profile',profile);
      

      // 创建订单
      const orderResult = await WxPayDao.createOrder(profile, this.from === 'wxapp')

      if (orderResult.code === 1) {
        this.paySignInfo = orderResult.data
        this.outTradeNo = orderResult.data.outTradeNo
        this.orderCreateTime = DateUtils.formateDate(new Date(), 'YYYY-MM-DD HH:mm:ss')

        // 调起支付
        if (this.from === 'wxapp') {
          this.launchMiniProgramPay()
        } else {
          this.launchWeChatPay()
        }
      } else {
        console.log('支付失败-订单创建失败', orderResult)
        Toast.fail('订单创建失败')
      }
    },

    // 计算支付金额
    calculateFee (patientMobile) {
      // 测试手机号支付0.01元
      if (this.testMobile.includes(patientMobile)) {
        return 0.01
      }

      return this.selectedPlan.price
    },

    // 构建订单数据
    buildOrderProfile (fee, patientName, patientMobile) {
      // 生成订单描述
      const goods = `康复指导小程序VIP会员-${this.selectedPlan.name}-患:${patientName}`
      const fromActivity = `康复指导小程序VIP会员-${this.selectedPlan.name}`
      this.remark = `康复指导小程序VIP会员-${this.selectedPlan.name}-${this.selectedPlan.duration}-${patientName}-${patientMobile}-医院ID:${this.hospitalId}`

      return {
        serveType: 0,
        mobile: patientMobile,
        patientName: patientName,
        patientMobile: patientMobile,
        orderType: 'vip_purchase',
        fee: fee,
        fromActivity: fromActivity,
        goods: goods,
        openId: this.openid,
        hospitalId: this.hospitalId, // 添加医院ID
        remark: this.remark
      }
    },

    // 小程序支付
    launchMiniProgramPay () {
      console.log('启动小程序支付')

      // 检查小程序环境
      if (!window.wx || !window.wx.miniProgram) {
        console.error('小程序环境检测失败，无法调用支付')
        Toast.fail('当前环境不支持小程序支付')
        return
      }

      // 构建支付参数
      this.paySignInfo.orderInfo = {
        outTradeNo: this.outTradeNo,
        orderCreateTime: this.orderCreateTime,
        remark: this.remark
      }

      const wxJson = JSON.stringify(this.paySignInfo)
      const encodedParam = encodeURIComponent(wxJson)

      console.log('小程序支付参数:', {
        paySignInfo: this.paySignInfo,
        wxJson: wxJson,
        encodedParam: encodedParam
      })

      // 跳转到小程序支付页面
      try {
        window.wx.miniProgram.navigateTo({
          url: `/pages/pay_submit_universe/pay_submit_universe?param=${encodedParam}`
        })
        console.log('小程序支付页面跳转成功')
      } catch (error) {
        console.error('小程序支付跳转失败:', error)
        Toast.fail('支付页面跳转失败')
      }
    },

    // 微信H5支付
    launchWeChatPay () {
      wx.config({
        debug: false,
        appId: this.paySignInfo.sign.appId,
        timestamp: this.paySignInfo.sign.timeStamp,
        nonceStr: this.paySignInfo.sign.nonceStr,
        signature: this.paySignInfo.sign.paySign,
        jsApiList: ['chooseWXPay']
      })

      wx.ready(() => {
        const _that = this
        wx.chooseWXPay({
          timestamp: this.paySignInfo.sign.timeStamp,
          nonceStr: this.paySignInfo.sign.nonceStr,
          package: this.paySignInfo.sign.packageValue,
          signType: this.paySignInfo.sign.signType,
          paySign: this.paySignInfo.sign.paySign,
          success: function (res) {
            if (res.errMsg === 'chooseWXPay:ok') {
              console.log('支付成功', res)
              _that.payStatus = true
              _that.onPaySuccess()
            } else {
              Dialog({ message: JSON.stringify(res) })
              _that.payStatus = false
            }
          },
          fail: function (res) {
            Dialog({ message: '支付失败:' + JSON.stringify(res) })
            _that.payStatus = false
          }
        })
      })

      wx.error((err) => {
        alert(err)
      })
    },

    // 支付成功处理
    onPaySuccess () {
      this.showPaySuccessPopup = true
      this.onClose()

      // 触发购买成功事件，传递套餐信息和订单信息
      this.$emit('purchase', {
        plan: this.selectedPlan,
        orderInfo: {
          outTradeNo: this.outTradeNo,
          orderCreateTime: this.orderCreateTime,
          remark: this.remark
        }
      })
    },

    // 获取微信配置
    async getAppid () {
      const url = '/quick/pay/appid'
      const res = await axios.get(url)
      this.appid = res.data.data.codeName
      this.appsecret = res.data.data.codeValue
    },

    // 获取微信OpenID流程
    async getMpOpenID () {
      const code = this.getUrlKey('code')
      if (code) {
        await this.getOpenId(code)
      } else {
        this.getCodeApi()
      }
    },

    // 通过Code获取OpenID
    async getOpenId (code) {
      const url = '/quick/pay/openid?code=' + code

      try {
        const res = await axios.get(url)
        this.openid = res.data.data.openid

        if (!this.openid) {
          this.getCodeApi()
          return
        }

        this.$store.commit('user/setOpenId', this.openid)
      } catch (err) {
        console.log('获取openid失败', err)
        this.getCodeApi()
      }
    },

    // 获取微信授权Code
    getCodeApi () {
      const appid = 'wxcb56667c309e369b' // 您的AppID
      const urlNow = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base' // 静默授权

      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}#wechat_redirect`

      window.location.href = url
    },

    // URL参数工具
    getUrlKey (name) {
      return decodeURIComponent(
        (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [undefined, ''])[1].replace(/\+/g, '%20')
      ) || null
    },

    // 关闭支付成功弹窗
    closeSuccessPopup () {
      this.showPaySuccessPopup = false
    }
  }
}
</script>

<style scoped>
.vip-popup {
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #fafbfc 0%, #f8fafc 100%);
  padding-bottom: 0;
  position: relative;
  overflow: hidden;
}

.vip-popup::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.08) 0%,
  rgba(255, 91, 46, 0.05) 50%,
  rgba(255, 193, 7, 0.03) 100%);
  pointer-events: none;
}

.vip-popup__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);
  border-bottom: 1px solid rgba(255, 143, 63, 0.1);
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.vip-popup__title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
}

.vip-popup__benefits {
  padding: 8px;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.12) 0%,
  rgba(255, 193, 7, 0.08) 50%,
  rgba(255, 91, 46, 0.06) 100%);
  position: relative;
  margin: 12px 8px 0px 8px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 143, 63, 0.15);
  flex-shrink: 0;
}

.vip-popup__benefits::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg,
  rgba(255, 255, 255, 0.1) 0%,
  transparent 50%,
  rgba(255, 255, 255, 0.05) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.benefits-title {
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.benefits-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  position: relative;
  z-index: 1;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.benefit-item:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 143, 63, 0.15);
}

.vip-popup__plans {
  flex: 1;
  padding: 16px 0px;
  overflow: visible;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

.plans-title {
  font-size: 16px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 16px;
  text-align: center;
  position: relative;
  flex-shrink: 0;
}

.plans-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  border-radius: 2px;
}

.plans-list {
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  padding: 4px 8px 8px 8px;
  flex: 1;
  align-items: stretch;
}

.plan-item {
  position: relative;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 12px 10px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  min-width: 150px;
  flex: 1;
  flex-shrink: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 200px;
}

.plan-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.05) 0%,
  rgba(255, 193, 7, 0.03) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.plan-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(255, 143, 63, 0.2);
}

.plan-item:hover::before {
  opacity: 1;
}

.plan-item--selected {
  border: 2px solid transparent;
  background: linear-gradient(135deg, #ffffff 0%, #fff7ed 100%);
  box-shadow: 0 8px 30px rgba(255, 143, 63, 0.25);
  transform: translateY(-2px);
}

.plan-item--selected::before {
  opacity: 1;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.1) 0%,
  rgba(255, 193, 7, 0.05) 100%);
}

.plan-item--selected::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.1) 0%,
  transparent 50%,
  rgba(255, 193, 7, 0.05) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.plan-item__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 6px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.plan-item__name {
  font-size: 14px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 4px;
  letter-spacing: 0.3px;
}

.plan-item__price-row {
  width: 100%;
}

.plan-item__price {
  display: flex;
  align-items: baseline;
}

.price-symbol {
  font-size: 16px;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

.price-amount {
  font-size: 22px;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.plan-item__duration {
  font-size: 11px;
  color: #ff8f3f;
  font-weight: 600;
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 143, 63, 0.2);
  box-shadow: 0 2px 4px rgba(255, 143, 63, 0.1);
  text-align: center;
}

.plan-item__service-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #ff8f3f;
  font-weight: 600;
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 143, 63, 0.2);
  box-shadow: 0 2px 4px rgba(255, 143, 63, 0.1);
  margin-top: 4px;
  justify-content: center;
}

.plan-item__features {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  z-index: 1;
  flex: 1;
  justify-content: flex-start;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #4a5568;
  font-weight: 500;
  padding: 1px 0;
  line-height: 1.3;
}

.plan-item__badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 0 16px 0 16px;
  box-shadow: 0 4px 12px rgba(255, 143, 63, 0.4);
  letter-spacing: 0.5px;
  z-index: 2;
}

.plan-item__badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
  rgba(255, 255, 255, 0.2) 0%,
  transparent 50%);
  border-radius: 0 16px 0 16px;
  pointer-events: none;
}

.vip-popup__footer {
  padding: 16px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border-top: 1px solid rgba(255, 143, 63, 0.1);
  position: relative;
  z-index: 1;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .benefits-list {
    grid-template-columns: 1fr;
  }

  .plan-item {
    min-width: 130px;
    padding: 10px 8px;
    max-height: 180px;
  }

  .plan-item__name {
    font-size: 13px;
  }

  .price-amount {
    font-size: 18px;
  }

  .vip-popup__benefits {
    margin: 0 12px;
    padding: 12px;
  }

  .vip-popup__plans {
    padding: 12px 16px;
  }

  .feature-item {
    font-size: 10px;
    gap: 4px;
  }
}

/* 滚动条美化 */
.plans-list::-webkit-scrollbar {
  height: 4px;
}

.plans-list::-webkit-scrollbar-track {
  background: rgba(255, 143, 63, 0.1);
  border-radius: 2px;
}

.plans-list::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  border-radius: 2px;
}

.plans-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #ff5b2e 0%, #ff8f3f 100%);
}

/* 支付成功弹窗样式 */
.success-popup-wrapper {
  z-index: 3000;
}

.success-popup {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border-radius: 20px;
  padding: 32px 24px 24px;
  width: 320px;
  max-width: 90vw;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.success-popup::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(135deg,
  rgba(255, 143, 63, 0.08) 0%,
  rgba(255, 193, 7, 0.05) 100%);
  pointer-events: none;
}

.success-popup__icon {
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.success-popup__title {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #07c160 0%, #06a94d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.success-popup__content {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid rgba(255, 143, 63, 0.1);
  backdrop-filter: blur(5px);
  position: relative;
  z-index: 1;
}

.success-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.success-info-item:last-child {
  border-bottom: none;
}

.success-info-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.success-info-item .value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  text-align: right;
  max-width: 60%;
  word-break: break-all;
}

.success-popup__tip {
  font-size: 13px;
  color: #ff8f3f;
  margin-bottom: 24px;
  padding: 12px;
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
  border-radius: 8px;
  border: 1px solid rgba(255, 143, 63, 0.2);
  position: relative;
  z-index: 1;
  line-height: 1.4;
}
</style>
